/**
 * 创建一个 intersection observer
 * 用于观察指定元素是否与 opts.root 元素相交
 * ps: opts.root 默认为 null，即为可视区域
 */
import 'intersection-observer';
export var DEFAULT_OPTS = {
    threshold: 0
};
export function createIntersectionObserver(elem, callback, opts) {
    if (opts === void 0) { opts = DEFAULT_OPTS; }
    var observer = new IntersectionObserver(callback, opts);
    observer.observe(elem);
    return observer;
}
//# sourceMappingURL=intersection.js.map